//
import i18n from "i18next";

import { initReactI18next } from "react-i18next";

import en from "./en.json";
import nl from "./nl.json";
import sr from "./sr.json";
import fr from "./fr.json";
import de from "./de.json";
import pt from "./pt.json";

const resources = { en, nl, sr, fr, de, pt } as const;

declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: typeof en;
    resources: (typeof resources)["en"];
  }
}

i18n.use(initReactI18next).init({
  resources,

  debug: process.env.NODE_ENV !== "production",

  lng: "en",
  fallbackLng: "en",

  keySeparator: ".",

  interpolation: {
    escapeValue: false,
  },
});
